export default __webpack_public_path__ + "static/media/ytvideo.9cd3d988.svg";